import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantConstant } from '@app-constants/tenant.constant';
import { AuthService } from '@app-services/auth-service/auth.service';
import { LoginService } from '@app-services/login/login.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { UserService } from '@app-services/user/user.service';
import { ClassService } from 'src/app/core/services/class.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { environment } from 'src/environments/environment';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { ForgotPasswordDialogComponent } from '../forgot-password-dialog/forgot-password-dialog.component';
import { openDefaultLoginDialog } from '@app-core/components/home/home.component';
import { clearLocalStorage, navigateBetweenProjects } from 'src/app/helpers/functions';
import { dashboardRoute } from '@app-constants/app.constants';

@Component({
  selector: 'app-password-login-dialog',
  templateUrl: './password-login-dialog.component.html',
  styleUrls: ['./password-login-dialog.component.css']
})
export class PasswordLoginDialogComponent implements OnInit {
  loginWithOtp = openDefaultLoginDialog;
  tenant : any = TenantConstant.tenant;
  loginForm!: FormGroup;
  login: any;
  phoneNumber : any;
  UnauthorizedLoginMessage: any = '';
  show_button: Boolean = false;
  loginWith: any = 'phoneNumber';
  panelTitle: any = "Please enter your registered phone number and password to get started";
  sendTrackAPIOnSignInOrSignUp: boolean = environment?.sendTrackAPIOnSignInOrSignUp;
  constructor(private dialog: MatDialog, private _formBuilder:FormBuilder,public router: Router,
    private userService: UserService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any, private loginService: LoginService,
    private testListService: TestlistService,
    private gaService: GAnalyticsService,
    private classService: ClassService,
    private dialogRef: MatDialogRef<PasswordLoginDialogComponent>) {
      // this.loginForm=_formBuilder.group({
      //   phone:[''],
      //   password: ['']
      // })
     }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    //console.log('data', this.data);
    this.login = this.data;
    this.phoneNumber = this.data.countryCode +' '+ this.data.phone;
    this.createloginForm();
    if (this.data.phone) {
      this.setLoginForm();
    }
  }
  createloginForm(): void {
    this.loginForm = this._formBuilder.group({
      phone: [null, [Validators.required, Validators.minLength(10)]],
      password: ['', Validators.required]
    })
  }
  setLoginForm(): void {
    this.loginForm = this._formBuilder.group({
      phone: [this.phoneNumber, [Validators.required, Validators.minLength(10)]],
      password: [this.login.password || '', [Validators.required]],
    });
    // this.loginForm.markAllAsTouched()
  }

  showPassword(): void {
    this.show_button = !this.show_button;
  }

  get l() { return this.loginForm.controls; }
  
  forgotPassword() {
    this.dialogRef.close();
    const config: MatDialogConfig = {
      width: '439px',
      panelClass:'forgot-pass-modal',
      data: { message: 'Forgot Password', message2: 'Please enter your registered phone number to reset password',
              countryCode: this.data.countryCode, phone: this.data.phone,
              actionData: this.data?.actionData
             }
    };
    const dialogRef = this.dialog.open(ForgotPasswordDialogComponent, config);
  }

  loginWithPassword() {
    this.loginForm.markAllAsTouched()
    this.loginForm.get('phone')?.setValue(this.data.phone);
    // console.log(this.loginForm.value, this.loginForm.countryCode);
    // console.log(parseInt(this.data.phone.replace(/ /g, "")));
    if(this.loginForm.valid){
      this.loginPassword(this.loginForm.value, this.login.countryCode)
    }
  }

  loginPassword(formValue: any, countryCode: string): any {
    this.gaService.sendEvent(
      'pwd_login_attempted', 
      'pwd_login', 
      'pwd_login_attempted', 
      'with_phone_number',  
    );
    clearLocalStorage();
    formValue.userActivityTrackingDataDto = !this.sendTrackAPIOnSignInOrSignUp 
      ? undefined 
      : {
        "data": {},
        "landingPage": ""
      },
    this.loginService.login(formValue, countryCode).subscribe((data:any) => {
      // this.toastr.success(data.message);
      //console.log(data);
      if (data.accessToken) {
        this.gaService.sendEvent(
          'pwd_login_succeeded',
          'pwd_login',
          'pwd_login_succeeded', 
          'with_phone_number',  
        );
        if(data && data.accessToken){

            this.gaService.sendEvent(
              'User Login',
              '',
              '',
              '',
              {'event': 'User Login' ,
              'Phone Number': data.userDto.phone,
              'First Name': data.userDto.firstName,
              'Last Name': data.userDto.lastName,
              'City': null,
              'Email ID': data.userDto.email,
              'Mode': null,
              'User Source': null,
              'Whatsapp_consent': data?.userDto?.whatsappConsent,
            }
      
            )
    
        }
        this.dialogRef.close();
        localStorage.setItem('token', data.accessToken)
        let gradeByName = data?.userDto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', '');
        this.userService.setMobileAndName({phone: data.userDto.phone, isdCode: data.userDto.isdCode, firstName: data.userDto.firstName, lastName: data.userDto.lastName,
          whatsappConsent: data.userDto.whatsappConsent, userId: data.userDto.userId, profilePhoto:data.userDto.profilePhoto, grade: Number(gradeByName)});
          this.userService.setUserTypes(data.userDto.userType);
          
        localStorage.setItem('studentid', formValue.phone)
        
        this.userService.updateRequestedUserData(data.userDto);
          let _headers = {
            'accesstoken': data.accessToken,
            'studentid':  `${formValue.phone}`,
            // 'methodtype': 'RULES'
          };

          this.test(_headers);
      } else { this.UnauthorizedLoginMessage = 'Incorrect Password! Try again'  }
    },
      (error) => {                                     // on error
        // this.toastr.warning(error.error.message)
        console.log(error);
        this.UnauthorizedLoginMessage = error.error.message
    });
  }

  test(_headers: any): any {
  if(this.data?.actionData?.redirection){
    // alert(this.data?.actionData?.redirection);
    //this.router.navigate([this.data?.actionData?.redirection]);
    navigateBetweenProjects(this.router, this.data?.actionData?.redirection);
  } else {
    let route = dashboardRoute;
      let userType = this.userService.getUserType()
      if(userType == 2){
        route += '/liveclass';
      } else {
        if(environment?.portal == 'teacher'){
          this.loginService.logoutEvent.emit({showPopup: true, message: 'Oops!', message2: `Seems like you are not a registerd teacher.`});
          return;
        }
      }
      navigateBetweenProjects(this.router, route);
  }
  }

  closeDialogue() {
    this.dialogRef.close();
  }

}
